import { EmptyInstance } from "core/features/components/mixins/empty-instance";
import { EventEmitterMixin } from "front-end/mixins/event-emitter.mixin";

export class EmergencyMessageComponent extends EventEmitterMixin(EmptyInstance) {
    public static SELECTOR = ".js-ina-emergency-message";

    private _currentContext: JQuery = $();

    private _body: JQuery = null;

    private _closeBtn: JQuery = null;

    private _title: JQuery = null;
    private _link: JQuery = null;

    private _classMap = {
        css: {
            hide: "hide",
            bodyOverflow: "body-overflow"
        },
        js: {
            closeBtn: `${EmergencyMessageComponent.SELECTOR}__close-button`,
            title: `${EmergencyMessageComponent.SELECTOR}__title`,
            link: `${EmergencyMessageComponent.SELECTOR}__cta-link`
        }
    };

    public show(): void {
        this._body.addClass(this._classMap.css.bodyOverflow);
        this._currentContext.removeClass(this._classMap.css.hide);
    }

    public hide(): void {
        this._body.removeClass(this._classMap.css.bodyOverflow);
        this._currentContext.addClass(this._classMap.css.hide);
    }

    private get title(): string {
        return this._title.text()?.trim() ?? "";
    }

    private get link(): string {
        return this._link.attr("href")?.trim() ?? "";
    }

    public getHash(): string {
        return `${this.title}${this.link}`.getHash();
    }

    private bindEvents(): void {
        this._closeBtn.on("click", e => {
            e.preventDefault();
            this.emit("close");
        });
    }

    private parseContext(): void {
        this._title = $(this._classMap.js.title, this._currentContext);
        this._link = $(this._classMap.js.link, this._currentContext);
        this._closeBtn = $(this._classMap.js.closeBtn, this._currentContext);
        this._body = $("body");
    }

    public init(currentContext: JQuery): void {
        this._currentContext = currentContext;

        this.parseContext();
        this.bindEvents();
    }
}
